"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowUpRight, Wrench, Thermometer, Crosshair, SlidersHorizontal as Sliders, Hexagon, FileSearch } from 'lucide-react';
import { Button } from "@/components/ui/button";
export default function Topdestinationsgrid() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const capabilities = [{
    code: "DEAL 001",
    title: "DIRECT HOTEL ACCESS",
    description: "We connect you directly to hotel inventory, bypassing expensive third-party platforms to ensure you get the absolute lowest price.",
    Icon: Wrench
  }, {
    code: "DEAL 002",
    title: "NO HIDDEN FEES",
    description: "Transparency is our core value. The price you see is the price you pay, with no surprise commissions or hidden service charges.",
    Icon: Thermometer
  }, {
    code: "DEAL 003",
    title: "INSTANT CONFIRMATION",
    description: "Secure your stay in Greece with real-time booking confirmation, ensuring your room is ready the moment you arrive.",
    Icon: Crosshair
  }, {
    code: "DEAL 004",
    title: "CURATED GREEK STAYS",
    description: "Hand-picked selection of hotels across Greece, optimized for budget-conscious travelers seeking quality and authentic experiences.",
    Icon: Sliders
  }, {
    code: "DEAL 005",
    title: "SECURE TRANSACTIONS",
    description: "Your payment data is protected by industry-leading encryption, providing peace of mind for every booking you make.",
    Icon: Hexagon
  }, {
    code: "DEAL 006",
    title: "LOCAL EXPERT SUPPORT",
    description: "Our team provides dedicated assistance for your Greek holiday, offering local insights and reliable customer service.",
    Icon: FileSearch
  }];
  return;
}
function CapabilityCard({
  cap,
  index,
  ...rest
}: {
  cap: {
    code: string;
    title: string;
    description: string;
    Icon: React.ComponentType<{
      className?: string;
      strokeWidth?: number;
    }>;
  };
  index: number;
  [key: string]: unknown;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const Icon = cap.Icon;
  return <div ref={ref} {...rest} className={`group relative bg-card backdrop-blur-md border border-border hover:border-primary/30 shadow-lg hover:shadow-xl transition-all duration-500 ease-out hover:-translate-y-1 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
    minHeight: "380px",
    padding: "40px",
    transitionDelay: isVisible ? `${index * 20}ms` : "0ms"
  }}>
      {}
      <span aria-hidden="true" className="absolute top-3 right-3 text-primary font-default pointer-events-none" style={{
      fontSize: "14px"
    }}>
        [ ]
      </span>
      <span aria-hidden="true" className="absolute bottom-3 left-3 text-primary font-default pointer-events-none" style={{
      fontSize: "14px"
    }}>
        [ ]
      </span>

      <div className="flex flex-col h-full">
        {}
        <div className="mb-6">
          <Icon className="text-primary group-hover:animate-pulse transition-transform duration-300" strokeWidth={1.25} />
        </div>

        {}
        <div className="font-default uppercase text-muted-foreground mb-3" style={{
        fontSize: "10px",
        letterSpacing: "0.15em"
      }}>
          {cap.code}
        </div>

        {}
        <h3 className="font-default font-bold text-foreground uppercase mb-4 leading-tight" style={{
        fontSize: "28px",
        letterSpacing: "-0.02em"
      }}>
          {cap.title}
        </h3>

        {}
        <p className="font-default text-foreground/70 leading-relaxed flex-grow" style={{
        fontSize: "15px"
      }}>
          {cap.description}
        </p>

        {}
        <div className="mt-6 flex justify-end">
          <Button variant="ghost" size="sm" className="h-auto p-0 hover:bg-transparent group/btn">
            <span className="font-default uppercase text-primary" style={{
            fontSize: "11px",
            letterSpacing: "0.15em"
          }}>
              LEARN MORE
            </span>
            <ArrowUpRight className="size-4 text-primary transition-transform duration-300 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5" strokeWidth={1.5} />
          </Button>
        </div>
      </div>
    </div>;
}